import LearnMore from '@app/components/LearnMore';
import { getInsuranceStateChipColor } from '@app/utils/insurance';
import { Chip } from 'easyship-components';
import React, { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { twMerge } from 'tailwind-merge';
import ClaimShipmentProvider from '../../providers/ClaimShipmentProvider';
import { useClaimShipmentContext } from '../../providers/ClaimShipmentProvider/context';
import { ClaimSummaryProps } from '../../types';
import ClaimDetails from './ClaimDetails';

function ClaimSummaryInner() {
  const { formatMessage } = useIntl();
  const { shipment, insuredState } = useClaimShipmentContext();
  const insuranceChipColor = useMemo(
    () => getInsuranceStateChipColor(insuredState),
    [insuredState]
  );
  const claim = shipment?.claim;

  if (!claim) {
    return null;
  }

  return (
    <div className="flex flex-col bg-white p-[10px] m-[5px] border border-sky-500 rounded-[2px]">
      <h2 className="text-lg text-ink-900 font-bold flex items-center justify-center mb-4">
        <FormattedMessage id="global.insurance" />
        <Chip
          color={insuranceChipColor}
          className={twMerge(
            'ml-2 rounded-full text-[14px]/[16px]',
            insuredState === 'self-insured' && 'bg-green-500' // override since ChipColor does not have the `bg-green-500` color
          )}
        >
          <FormattedMessage id={`shipments.modal.insurance.state.${insuredState}`} />
        </Chip>
      </h2>
      <ClaimDetails claim={claim} />
      <LearnMore
        className="justify-center mt-8 text-base"
        sectionName={formatMessage({ id: 'insurance-claim.select.section-name' })}
        supportLink="/hc/en-us/articles/360012274532-Insurance-Claim"
      />
    </div>
  );
}

export function ClaimSummary(props: ClaimSummaryProps) {
  const { shipmentId, ...rest } = props;
  return (
    <ClaimShipmentProvider shipmentId={shipmentId}>
      <ClaimSummaryInner {...rest} />
    </ClaimShipmentProvider>
  );
}

export default ClaimSummary;
